import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  getTopicAmount(topic) {
    let url = buildUrl("notifications/topic/amount/" + topic)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  sendPushToTopic(notification) {
    let url = buildUrl("notifications/topic")
    return axios.post(url, notification, buildOptions()).then((res) => res.data)
  },
  sendPushToUser(notification) {
    let url = "https://app.wellcomefit.ch/api/send/push/to/user"
    //let url = buildUrl("send/push/to/user")
    return axios.post(url, notification, buildOptions()).then((res) => res.data)
  },

  readNotification(id) {
    let url = buildUrl("notifications/read/" + id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchNotifications() {
    let url = buildUrl("notifications")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
}
